export default __webpack_public_path__ + "static/media/icon-noimg@3x.9c6ef45a.png";